export function deferAction(action){setTimeout(action,1)}export var inlineProp=function(name,value){var obj={};return obj[name]=value,obj};